module.exports = __webpack_public_path__ + "media/images/menu_s-ee8323894fefc6681fe82777a577c3af.gif";